import { IOnInit, IPromise } from "angular";
import { StateService } from "@uirouter/angularjs";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../grids/settings/gridSettingsService";
import { RecordDataSource } from "../../../grids/recordDataSource";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../views/recordGridView";
import {
  LookupEditModalService,
  vsServiceName as LookupEditModalServiceName,
} from "../../lookupEditModal";
import { startCase } from "lodash";
import { LookupManagementConfig } from "../service";
import {
  ReferenceRelationship,
  ReferenceRelationshipCollection,
} from "../../../server/references";

type referenceInfo = {
  gridConfiguration: GridConfiguration;
  relationship: ReferenceRelationship;
  name: string;
  displayName: string;
};

export class LookupDetailController implements IOnInit {
  static $inject = [
    GridSettingsServiceName,
    ServerUtilityName,
    RecordGridViewServiceName,
    LookupEditModalServiceName,
    "$state",
  ];
  private readonly lookUpID!: number;
  private readonly lookupReferences!: ReferenceRelationshipCollection;
  private readonly lookupManagementConfig!: LookupManagementConfig;
  private readonly lookupType!: string;

  private gridConfigs: referenceInfo[] = [];

  selectedReference: referenceInfo | undefined;

  constructor(
    private readonly gridSettingsService: GridSettingsService,
    private readonly serverUtility: ServerUtility,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly lookupEditModalService: LookupEditModalService,
    private readonly $state: StateService
  ) {}
  $onInit() {
    this.gridConfigs = Object.entries(this.lookupReferences).map((entry) => {
      const [name, relationship] = entry;
      return {
        name,
        relationship,
        gridConfiguration: this.getGridConfig(relationship)!,
        displayName: startCase(name),
      };
    });
    
    this.gridConfigs.sort((left, right) => left.name.localeCompare(right.name));

    this.selectedReference = this.gridConfigs[0];
  }
  getGridConfig(
    relationship: ReferenceRelationship
  ): GridConfiguration | undefined {
    const referencingRecordDefinition =
      relationship.ReferencingRecordDefinition;
    const gridConfig = this.recordGridViewService.getGridConfiguration(
      referencingRecordDefinition
    );

    if (!gridConfig) return undefined;

    gridConfig.gridSettings = this.gridSettingsService.getGridSettings(
      Symbol("main.machines.lookups.grid." + referencingRecordDefinition)
    );

    const url = gridConfig.gridDataSource!.url;

    gridConfig.gridDataSource = new RecordDataSource(
      this.serverUtility,
      `${url}/references/${this.lookupType}/${this.lookUpID}`
    );
    return gridConfig;
  }

  typeSelected(reference: referenceInfo) {
    this.selectedReference = reference;
  }

  OnDeleteButtonClick(): IPromise<void> {
    return this.lookupEditModalService
      .openModal({
        lookupId: this.lookUpID,
        lookupManagementConfig: this.lookupManagementConfig,
      })
      .then((modalInstance) => modalInstance.result)
      .then(() => {
        this.$state.go("^.grid", { reload: true });
      });
  }
}
